import { Navigate, useLocation } from 'react-router-dom';

import { getUserRole, isAuthenticated } from 'utils/auth';

export default function ProtectedRoute({
  roles = ['SUPER_ADMIN', 'ADMIN'],
  children,
}: {
  roles?: string[];
  children: JSX.Element;
}) {
  let location = useLocation();
  const userRole = getUserRole();

  // return isAuthenticated() ? (
  //   roles.includes(userRole) ? (
  //     children
  //   ) : (
  //     <RouteAccessDenied />
  //   )

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!roles.includes(userRole) && location.pathname === '/') {
    return <Navigate to="/departments" />;
  }

  return children;
}
